var map = {
	"./br": "eyY4",
	"./br.ts": "eyY4",
	"./br/br": "t7f1",
	"./br/br.json": "t7f1",
	"./br/en": "jqRk",
	"./br/en.json": "jqRk",
	"./en": "qE6L",
	"./en.ts": "qE6L",
	"./id": "Lgso",
	"./id.ts": "Lgso",
	"./id/en": "LUiq",
	"./id/en.json": "LUiq",
	"./id/id": "VucT",
	"./id/id.json": "VucT",
	"./my": "sOjy",
	"./my.ts": "sOjy",
	"./my/en": "XXAd",
	"./my/en.json": "XXAd",
	"./my/ms-my": "LSyC",
	"./my/ms-my.json": "LSyC",
	"./my/zh-Hans": "kgKi",
	"./my/zh-Hans.json": "kgKi",
	"./ph/en": "5L9+",
	"./ph/en.json": "5L9+",
	"./th": "WJCV",
	"./th.ts": "WJCV",
	"./th/en": "2TQf",
	"./th/en.json": "2TQf",
	"./th/th": "upUH",
	"./th/th.json": "upUH",
	"./vn": "vCzR",
	"./vn.ts": "vCzR",
	"./vn/en": "ay3C",
	"./vn/en.json": "ay3C",
	"./vn/vi": "ZkZ8",
	"./vn/vi.json": "ZkZ8",
	"./zh": "Fcnu",
	"./zh.ts": "Fcnu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/KVF";